import { Routes, Route } from "react-router-dom";
import { ADMIN_BINGO_GAMES_PATH, ADMIN_BINGO_TEMPLATES_PATH } from "_urls";
import { BingoTemplatesAdminListView } from "bingo/views/BingoTemplatesAdminListView";
import { BingoTemplateAdminView } from "bingo/views/BingoTemplateAdminView";
import { BingoMainAdminView } from "bingo/views/BingoMainAdminView";
import { BingoGamesAdminListView } from "bingo/views/BingoGamesAdminListView";
import { BingoGameAdminView } from "bingo/views/BingoGameAdminView";

export function BingoAdminRoutes() {
  return (
    <Routes>
      <Route path="" element={<BingoMainAdminView />} />
      <Route
        path={`${ADMIN_BINGO_TEMPLATES_PATH}`}
        element={<BingoTemplatesAdminListView />}
      />
      <Route
        path={`${ADMIN_BINGO_TEMPLATES_PATH}/new`}
        element={<BingoTemplateAdminView isCreateMode={true} />}
      />
      <Route
        path={`${ADMIN_BINGO_TEMPLATES_PATH}/:bingoTemplateId`}
        element={<BingoTemplateAdminView isCreateMode={false} />}
      />
      <Route
        path={`${ADMIN_BINGO_TEMPLATES_PATH}/:bingoTemplateId/duplicate`}
        element={<BingoTemplateAdminView isCreateMode={false} />}
      />

      <Route
        path={`${ADMIN_BINGO_GAMES_PATH}`}
        element={<BingoGamesAdminListView />}
      />
      <Route
        path={`${ADMIN_BINGO_GAMES_PATH}/:bingoGameId`}
        element={<BingoGameAdminView isCreateMode={false} />}
      />
      <Route
        path={`${ADMIN_BINGO_GAMES_PATH}/new`}
        element={<BingoGameAdminView isCreateMode={true} />}
      />
    </Routes>
  );
}
